export enum LifecycleStageMMHW {
  CONTRACT_PREPARATION = 'Contract Preparation',
  CONSTRUCTION = 'Construction',
}
